module.exports = __webpack_public_path__ + "static/media/no-data.82f570f2.svg";